import React from 'react';

import SideItem from './SideItem';

import {
  userInfoSelector,
  roleSettingsSelector,
} from 'redux/slices/app/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { permissions } from 'constant/permissions';
import { hasPermission } from 'utils/helper';
import {
  sideBarInfoSelector,
  updateSideBarInfoField,
} from 'redux/slices/sideBar/sideBarSlice';
import { IconButton } from 'components';
import MinSideItem from './MinSideItem';
const Sidebar = () => {
  const sideBarInfo = useSelector(sideBarInfoSelector);
  const userInfo = useSelector(userInfoSelector);
  const dispatch = useDispatch();
  const roleSettingsInfo = useSelector(roleSettingsSelector);
  const subItems = [
    {
      title: 'Gönderiler',
      isCustomElement: false,
      customElement: null,
      field: 'shipments',
      subItems: [],
      route: hasPermission(permissions.allCurrents, 'VIEW', roleSettingsInfo)
        ? '/gonderiler'
        : `/gonderiler/${userInfo?.customerId}`,
      contain: '/gonderi',
      icon: <i className="fa-solid fa-cart-flatbed text-primary" />,
      view: true,
    },
    {
      title: 'Cariler',
      isCustomElement: false,
      customElement: null,
      field: 'current',
      subItems: [
        {
          title: 'Cari',
          route: hasPermission(
            permissions.allCurrents,
            'VIEW',
            roleSettingsInfo
          )
            ? '/cari'
            : `/cari/${userInfo?.customerId}`,
          view: true,
        },
        {
          title: 'Cari Ekle',
          route: '/cari-olustur',
          view:
            hasPermission(
              permissions.allCurrents,
              'CREATE',
              roleSettingsInfo
            ) &&
            hasPermission(permissions.allCurrents, 'VIEW', roleSettingsInfo),
        },
      ],
      route: '/cari',
      icon: <i className="fa-brands fa-gg-circle text-primary" />,
      view: true,
    },
    {
      title: 'Adresler',
      isCustomElement: false,
      customElement: null,
      field: 'address',
      subItems: [
        {
          title: 'Adres Defteri',
          route: hasPermission(
            permissions.allCurrents,
            'VIEW',
            roleSettingsInfo
          )
            ? '/adresler'
            : `/adres/${userInfo?.customerId}`,
          view: true,
        },
      ],
      route: '/adresler',
      contain: '/adres',
      icon: <i className="fa-solid fa-address-book text-primary" />,
      view: true,
    },
    {
      title: 'Raporlar',
      isCustomElement: false,
      customElement: null,
      field: 'reports',
      subItems: [
        {
          title: 'Konşimento Raporu',
          route: '/konsimento-raporu',
          view: hasPermission(
            permissions.shipmentReport,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Kullanıcı Kontrol Raporu',
          route: '/kullanici-kontrol-raporu',
          view: hasPermission(permissions.userReport, 'VIEW', roleSettingsInfo),
        },
      ],
      route: '/raporlar/',
      icon: <i className="fa-solid fa-file text-primary" />,

      view: !(
        !hasPermission(permissions.shipmentReport, 'VIEW', roleSettingsInfo) &&
        !hasPermission(permissions.userReport, 'VIEW', roleSettingsInfo)
      ),
    },
    {
      title: 'Tanımlamalar',
      isCustomElement: false,
      customElement: null,
      field: 'definition',
      subItems: [
        {
          title: 'Kullanıcı',
          route: '/kullanici-tanimlama',
          view: hasPermission(
            permissions.userDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Roller',
          route: '/roller',
          view: hasPermission(
            permissions.roleDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Yetki',
          route: '/yetki-tanimlama',
          view: hasPermission(
            permissions.permissionDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Servis',
          route: '/servisler',
          view: hasPermission(
            permissions.serviceDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Servis Grupları',
          route: '/servis-gruplari',
          view: hasPermission(
            permissions.bookServiceGroupDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Servis Tipi',
          route: '/servis-tipleri',
          view: hasPermission(
            permissions.serviceTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Teslimat Şekli',
          route: '/teslimat-tipleri',
          view: hasPermission(
            permissions.deliveryTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Teslimat Biçimi',
          route: '/teslimat-bicimleri',
          view: hasPermission(
            permissions.deliveryTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Para Birimi',
          route: '/para-birimleri',
          view: hasPermission(
            permissions.currencyDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Evrak Tipleri',
          route: '/evrak-tipi-tanimlama',
          view: hasPermission(
            permissions.documentTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Durum Tipleri',
          route: '/durum-tipleri',
          view: hasPermission(
            permissions.statusTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Kap Türleri',
          route: '/kap-turleri',
          view: hasPermission(
            permissions.containerTypeDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
        {
          title: 'Fiyatlar',
          route: '/fiyatlar',
          view: hasPermission(
            permissions.pricesDefinition,
            'VIEW',
            roleSettingsInfo
          ),
        },
      ],
      route: '/landing',
      contain: '/edit-user',
      icon: <i className="fa-solid fa-gear text-primary" />,
      view: !(
        !hasPermission(
          permissions.statusTypeDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.documentTypeDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.currencyDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.deliveryTypeDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.serviceTypeDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.serviceDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.permissionDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(permissions.roleDefinition, 'VIEW', roleSettingsInfo) &&
        !hasPermission(permissions.userDefinition, 'VIEW', roleSettingsInfo) &&
        !hasPermission(permissions.allCurrents, 'VIEW', roleSettingsInfo) &&
        !hasPermission(
          permissions.containerTypeDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.pricesDefinition,
          'VIEW',
          roleSettingsInfo
        ) &&
        !hasPermission(
          permissions.bookServiceGroupDefinition,
          'VIEW',
          roleSettingsInfo
        )
      ),
    },
  ];

  const handleMinimize = () => {
    dispatch(updateSideBarInfoField({ value: !sideBarInfo.min, field: 'min' }));
  };

  return (
    <>
      {sideBarInfo.min ? (
        <div className="relative hidden md:block p-2 w-16 text-center transition-all h-full bg-sky-lighter rounded-lg border border-default-border">
          {subItems.map((item) =>
            !item.isCustomElement
              ? item.view && (
                  <MinSideItem
                    key={item.route}
                    route={item.route}
                    isCustomElement={item.isCustomElement}
                    subItems={item.subItems.filter((item) => item.view)}
                    icon={item.icon}
                    contain={item.contain}
                    field={item.field}
                  />
                )
              : item.customElement
          )}
          <IconButton
            className="absolute top-1 -right-3 bg-primary rounded-lg px-2 text-white z-10"
            icon={<i className="fa-solid fa-arrow-right fa-xs"></i>}
            onClick={handleMinimize}
          />
        </div>
      ) : (
        <div className="relative hidden md:block p-2 w-60 text-center transition-all h-full  bg-sky-lighter rounded-lg border border-default-border">
          <div className="h-full overflow-y-auto">
            {subItems.map((item) =>
              !item.isCustomElement
                ? item.view && (
                    <SideItem
                      key={item.route}
                      title={item.title}
                      route={item.route}
                      isCustomElement={item.isCustomElement}
                      subItems={item.subItems.filter((item) => item.view)}
                      icon={item.icon}
                      contain={item.contain}
                      field={item.field}
                    />
                  )
                : item.customElement
            )}
          </div>

          <IconButton
            className="absolute top-1 -right-3 bg-primary rounded-lg px-2 text-white z-10"
            icon={<i className="fa-solid fa-arrow-left fa-xs"></i>}
            onClick={handleMinimize}
          />
        </div>
      )}
    </>
  );
};

export default Sidebar;
